/* Shared helpers for wishlist, quick-add sheet, cart recommendations and search suggestions. */
(function () {
  if (window.NvCore) return;
  var root = function () { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); };
  var cache = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src; // only Shopify image URLs understand ?width=
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var n = (Number(cents) || 0) / 100;
    if (cur === 'INR') return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); } catch (e) { return cur + ' ' + n.toFixed(2); }
  }

  function product(handle) {
    if (!cache[handle]) {
      var p = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); });
      cache[handle] = p;
      p.catch(function () { delete cache[handle]; });
    }
    return cache[handle];
  }

  // plain XHR on purpose: festival animations only listen to fetch()
  function add(id, qty, props) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', root() + 'cart/add.js');
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        var d = {}; try { d = JSON.parse(x.responseText); } catch (e) { /* ignore */ }
        if (x.status >= 200 && x.status < 300) resolve(d);
        else reject(new Error(d.description || d.message || 'This item could not be added.'));
      };
      x.onerror = function () { reject(new Error('Network problem. Please try again.')); };
      var item = { id: Number(id), quantity: qty || 1 };
      if (props) item.properties = props;
      x.send(JSON.stringify({ items: [item] }));
    });
  }

  function refreshCart() {
    if (window.nvRefreshCart) return window.nvRefreshCart();
    var d = document.querySelector('cart-drawer');
    if (d && d.renderContents) return d.renderContents();
  }

  function handleOf(href) {
    try {
      var m = new URL(href, location.href).pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  // places where a product card must NOT get a heart / be treated as a card
  var EXCLUDE = 'header, footer, nav, cart-drawer, cart-notification, cart-items, .cart-items, product-info, .nv-sheet, .nv-reco, .nv-wl, predictive-search, [data-search-results], form[action*="/cart"]';

  // biggest box around `start` that holds exactly ONE product link
  function findCard(start) {
    var node = start, best = null, link = null;
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1) {
        var links = node.querySelectorAll('a[href*="/products/"]');
        var seen = {}, count = 0;
        for (var i = 0; i < links.length; i++) {
          var k = handleOf(links[i].href);
          if (k && !seen[k]) { seen[k] = links[i]; count++; }
          if (count > 1) break;
        }
        if (count > 1) break;
        if (count === 1) { best = node; link = seen[Object.keys(seen)[0]]; }
      }
      node = node.parentNode;
    }
    return best ? { card: best, link: link } : null;
  }

  function toast(html, ms) {
    var t = document.querySelector('.nv-toast');
    if (!t) { t = document.createElement('div'); t.className = 'nv-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(t.__t);
    t.__t = setTimeout(function () { t.classList.remove('is-on'); }, ms || 2600);
  }

  window.NvCore = { esc: esc, img: img, money: money, product: product, add: add, refreshCart: refreshCart, handleOf: handleOf, findCard: findCard, toast: toast, EXCLUDE: EXCLUDE };
})();
